import { useEffect, useMemo } from 'react';
import { filterRedeemedOrExpired } from '../components/RewardsPage/ui/templates/CertificateHistoryTab/helpers';
import { PAGE_NAMES, PageType } from '../const/analytics';
import triggerAnalyticsEvent from '../helpers/triggerAnalytics';
import useRewards from './useRewards';
import sortEarnings from '../helpers/sortEarnings';
var useRewardsAnalytics = function (_a) {
    var _b, _c, _d, _e;
    var allRewardsCertificate = _a.allRewardsCertificate, _f = _a.pageSubFunction, pageSubFunction = _f === void 0 ? '' : _f, _g = _a.clientName, clientName = _g === void 0 ? '' : _g, pageType = _a.pageType;
    var _h = useRewards(), rewardsBalance = _h.rewardsBalance, cardType = _h.cardType, clientId = _h.clientId, rewardsExperience = _h.rewardsExperience, rewardDetails = _h.rewardDetails, isLoading = _h.isLoading, isError = _h.isError;
    var isNotErrorOrLoading = !isLoading && !isError;
    var currentPtsBalanceValue = (_b = rewardDetails === null || rewardDetails === void 0 ? void 0 : rewardDetails.currentptsbalance) === null || _b === void 0 ? void 0 : _b.value;
    var currentBalanceDollarsValue = (_c = rewardDetails === null || rewardDetails === void 0 ? void 0 : rewardDetails.CurrentBalanceDollars) === null || _c === void 0 ? void 0 : _c.value;
    var earnings = (_e = (_d = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _d === void 0 ? void 0 : _d[cardType]) === null || _e === void 0 ? void 0 : _e.earnings;
    var sortedEarnings = useMemo(function () { return sortEarnings({ rewardsBalance: rewardsBalance, earningsIcons: earnings === null || earnings === void 0 ? void 0 : earnings.icons }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rewardsBalance === null || rewardsBalance === void 0 ? void 0 : rewardsBalance.rewardDetails, earnings === null || earnings === void 0 ? void 0 : earnings.icons]);
    var isEmptyEarnings = useMemo(function () { return sortedEarnings === null || sortedEarnings === void 0 ? void 0 : sortedEarnings.every(function (earning) { return Number(earning.value) === 0; }); }, [sortedEarnings]);
    var filteredRedeemedOrExpired = useMemo(function () {
        return allRewardsCertificate
            ? filterRedeemedOrExpired(allRewardsCertificate.certificateDetails)
            : [];
    }, [allRewardsCertificate]);
    var isCurrentBalanceDollarsZero = useMemo(function () {
        return currentBalanceDollarsValue !== undefined &&
            Number(currentBalanceDollarsValue) === 0;
    }, [currentBalanceDollarsValue]);
    var isEmptyCertificates = useMemo(function () {
        var noCertBalanceSumAndCurrentBalance = Number(allRewardsCertificate === null || allRewardsCertificate === void 0 ? void 0 : allRewardsCertificate.certificateBalanceSum) === 0 &&
            Number(currentPtsBalanceValue) === 0;
        var noCertificateHistory = !filteredRedeemedOrExpired.length;
        return ((pageType === PageType.CertificateTab && noCertificateHistory) ||
            noCertBalanceSumAndCurrentBalance);
    }, [
        allRewardsCertificate === null || allRewardsCertificate === void 0 ? void 0 : allRewardsCertificate.certificateBalanceSum,
        currentPtsBalanceValue,
        filteredRedeemedOrExpired.length,
        pageType
    ]);
    useEffect(function () {
        if (!isNotErrorOrLoading)
            return;
        var pageName = PAGE_NAMES.VIEW;
        var hasNoCertificates = (allRewardsCertificate === null || allRewardsCertificate === void 0 ? void 0 : allRewardsCertificate.certificateBalanceSum) &&
            currentPtsBalanceValue &&
            isEmptyCertificates;
        var hasNoEarnings = (sortedEarnings === null || sortedEarnings === void 0 ? void 0 : sortedEarnings.length) && isEmptyEarnings;
        var hasCurrentBalanceDollarsZero = currentBalanceDollarsValue && isCurrentBalanceDollarsZero;
        if (hasNoCertificates || hasNoEarnings || hasCurrentBalanceDollarsZero) {
            pageName = PAGE_NAMES.EMPTY;
        }
        triggerAnalyticsEvent({
            clientName: clientName,
            pageSubFunction: pageSubFunction,
            pageName: pageName
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allRewardsCertificate === null || allRewardsCertificate === void 0 ? void 0 : allRewardsCertificate.certificateBalanceSum,
        clientName,
        isEmptyEarnings,
        currentPtsBalanceValue,
        currentBalanceDollarsValue,
        sortedEarnings === null || sortedEarnings === void 0 ? void 0 : sortedEarnings.length,
        isNotErrorOrLoading
    ]);
};
export default useRewardsAnalytics;
